import CryptoJS from 'crypto-js/crypto-js';

// 默认的 KEY 与 iv 如果没有给
const KEY = CryptoJS.enc.Utf8.parse('1234567812345678'); //""中与后台一样  密码
const IV = CryptoJS.enc.Utf8.parse('1234567812345678'); //""中与后台一样

/**
 * AES加密 ：字符串 key iv  返回base64
 */
export function Encrypt(word, keyStr, ivStr) {
    let key = KEY;
    let iv = IV;

    if (keyStr) {
        key = CryptoJS.enc.Utf8.parse(keyStr);
        iv = CryptoJS.enc.Utf8.parse(ivStr);
    }

    let srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}
/**
 * @description: 将时间戳格式转换成年月日时分秒
 * @param {time} 需要转化的时间戳
 * @return {string}
 * ---> YYYY-MM-DD hh:mm:ss
 */
export function formatDate(time) {
    //将时间戳格式转换成年月日时分秒
    var date = new Date(time);
    var Y = date.getFullYear() + '-';
    var M =
        (date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1) + '-';
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';

    var h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':';
    var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    var strDate = Y + M + D + h + m + s;
    return strDate;
}
/**
 * AES 解密 ：字符串 key iv  返回base64
 *
 */
export function Decrypt(word, keyStr, ivStr) {
    let key = KEY;
    let iv = IV;

    if (keyStr) {
        key = CryptoJS.enc.Utf8.parse(keyStr);
        iv = CryptoJS.enc.Utf8.parse(ivStr);
    }

    let base64 = CryptoJS.enc.Base64.parse(word);
    let src = CryptoJS.enc.Base64.stringify(base64);

    var decrypt = CryptoJS.AES.decrypt(src, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
}
/**
 * 防抖函数
 * time：放抖限制时间，默认1秒
 * 用法：
 *  1、new出新防抖对象：debounce: new this.$Debounce(500)
 *  2、调用防抖对象的执行函数run：this.debounce.run(() => Do something);
 */
export class Debounce {
    constructor(time) {
        this.timer = null;
        this.time = time || 1000 * 1;
    }
    run(cb) {
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(cb, this.time);
    }
}
